import { render, staticRenderFns } from "./InviteNotFound.vue?vue&type=template&id=2ddd1d29&scoped=true&"
import script from "./InviteNotFound.vue?vue&type=script&lang=ts&"
export * from "./InviteNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./InviteNotFound.vue?vue&type=style&index=0&id=2ddd1d29&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd1d29",
  null
  
)

export default component.exports